import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ScheduleCallResponse } from '../../models/schedule-peer-call/scheduleCallResponse';
import { Store } from '@ngxs/store';
import { UserSelectors } from '../../states/user/user-selector';
import { UserStateModel } from '../../states/user/user-state-model';
import { SchedulePeerCallService } from '../../services/schedule-peer-call/schedule-peer-call.service';
import { of, switchMap } from 'rxjs';
import { FormControlPipe } from "../../utility/pipes/formControlPipe";
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-peer-meetings',
  standalone: true,
  imports: [CalendarModule, ReactiveFormsModule, FileUploadModule, DialogModule, CommonModule, FormsModule, ToggleButtonModule, InputTextModule, TableModule, ButtonModule, DropdownModule],
  templateUrl: './peer-meetings.component.html',
  styleUrl: './peer-meetings.component.scss'
})
export class PeerMeetingsComponent implements OnInit {

  totalRecords: number = 0;
  first: number = 0;
  rowSize: number = 10;
  pageSize = 10;
  meetingList: ScheduleCallResponse[] = [];
  meetingUrlForm!: FormGroup;

  user: UserStateModel | undefined;
  isLoading: boolean = false;

  constructor( private store: Store,
    private schedulePeerCallService: SchedulePeerCallService,
    private formBuilder: FormBuilder,
    private messageService: MessageService
  ){

  }
  initializeForm(){
    this.meetingUrlForm = this.formBuilder.group({
      url: this.formBuilder.array([])
    })
  }
  get urlArray(): FormArray{
    return this.meetingUrlForm.get('url') as FormArray;
  }
  getFormControl(index: number): FormControl {
    return this.urlArray.at(index) as FormControl;
  }

  ngOnInit(): void {
      this.loadMeetingData();
      
  }

  onSendMeetingUrl(index: number){
    const url = this.urlArray.at(index).value;
    const meeting = this.meetingList[index];

    console.log('Meeting URL:', url);
    console.log('Meeting:', meeting.id);

    this.schedulePeerCallService.setPeerStudentMeetingUrl({
      scheduledCallId: meeting.id,
      meetingUrl: url
    }).subscribe({
      next: (response) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Meeting Url sent successfully!' });
        this.loadMeetingData();
      }
    })
  }

  loadMeetingData() {
    this.isLoading = true;
    this.store.select(UserSelectors.getUser).pipe(
      switchMap(user => {
        if (!user || !user.id) {
          return of(null);
        }
        this.user = user;
        return this.schedulePeerCallService.getAllScheduledCallsForPeer(user.id);
      })
    ).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.meetingList = response?.result ?? [];
        this.totalRecords = response?.total ?? 0;
        this.initializeForm();
        
        this.meetingUrlForm.reset();
        this.meetingList.forEach(meeting => {
          this.urlArray.push(new FormControl(meeting.meetingUrl ??''));
        });
      },
      error: (error) => {
        this.isLoading = false;
        console.warn('Error fetching user and meeting list:', error);
      }
    });
  }

  onSubmit(){

  }

  deleteScheduleCall(){
    this.schedulePeerCallService.deleteScheduledCall('123').subscribe({
      next: (response) => {
        console.log('Deleted:', response);
        this.loadMeetingData();
      },
      error: (error) => {
        console.warn('Error deleting scheduled call:', error);
      }
    });
  }


  onLazyLoad($event: TableLazyLoadEvent): void {
      const pageNumber = Math.floor(($event.first ?? 0) / ($event.rows ?? this.rowSize)) + 1;
      this.first = $event.first ?? 0;
      this.rowSize = $event.rows ?? this.rowSize;
      this.loadMeetingData();
    }
}
